import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    parent: {
        flex: 1,
        justifyContent: 'center',
    },
    container: {
        flex: 1,
        height: Dimensions.get('window').height,
        backgroundColor: theme.colors.colorPrimary,
    },
    buttonContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        padding: 15,
        bottom: 25,
        width: '100%',
    },
    paddingBottom: {
        paddingBottom: 50,
    },

    imageBackground: {
        width: '100%',
        height: '100%',
    },
    feedbackContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 65,
    },
    feedbackAssetContainer: {
        paddingBottom: 4,
    },
    feedbackInfoContainer: {},
    feedbackAsset: {
        justifyContent: 'center',
        width: width / 1.5,
        height: width / 1.5,
    },
    labelAsset: {
        width: width,
        height: 200,
    },
    feedbackTitle: {
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.alert,
        marginBottom: 55,
    },
    feedbackDescription: {
        fontSize: 18,
        textAlign: 'center',
        lineHeight: 25,
        color: theme.colors.textPrimary,
        paddingHorizontal: 20,
        marginHorizontal: 12,
        marginBottom: 30,
    },
})

export default styles
